import './App.css';
import Condition from './components/Condition'

import conditionData from './data/data_models';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Dr. Flowchart</h1>
        <h4><em>Helping You Choose the Right Over-the-Counter Medicine</em></h4>
      </header>
      <div style={{ paddingTop: "10px" }}>
        <Condition cond={conditionData[0]} />
      </div>
      <footer className="App-footer">
        <em>
          This page does not provide medical advice. It is intended for informational purposes only. It is not a substitute for professional medical advice, diagnosis or treatment. Never ignore professional medical advice in seeking treatment because of something you have read on this site. If you think you may have a medical emergency, immediately call your doctor or dial 911.
        </em>
      </footer>
    </div >
  );
}

export default App;
